<ng-container *ngIf="ngIfCondition">
    <ng-content></ng-content>
</ng-container>